import React from 'react';  
import { motion } from 'framer-motion';  
import { Activity } from 'lucide-react';  

const Loading = () => {  
  return (  
    <div className="fixed inset-0 bg-black flex items-center justify-center z-50">  
      <motion.div  
        initial={{ opacity: 0, scale: 0.8 }}  
        animate={{ opacity: 1, scale: 1 }}  
        transition={{ duration: 0.5 }}  
        className="text-center"  
      >  
        <motion.div  
          animate={{ rotate: 360 }}  
          transition={{ duration: 1, repeat: Infinity, ease: "linear" }}  
          className="mb-4 flex justify-center"  
        >  
          <Activity size={48} className="text-white" />  
        </motion.div>  
        <p className="text-white text-lg font-semibold">Inicializando red AVO...</p>  
        <p className="text-gray-400 text-sm mt-2">Resultados inesperados en proceso</p>  
      </motion.div>  
    </div>  
  );  
};  

export default Loading;